/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type PowerConsumptionControllerV1GetPowerConsumptionReportFormat =
  (typeof PowerConsumptionControllerV1GetPowerConsumptionReportFormat)[keyof typeof PowerConsumptionControllerV1GetPowerConsumptionReportFormat];

export const PowerConsumptionControllerV1GetPowerConsumptionReportFormat = {
  JSON: 'json',
  CSV: 'csv',
} as const;
